import { ReactNode } from "react";
import { useBrokerAdminAccess } from "@/hooks/useBrokerAdminAccess";
import { Loader2 } from "lucide-react";

interface ProtectedAdminRouteProps {
  children: ReactNode;
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isVerified, isLoading } = useBrokerAdminAccess();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isVerified) {
    return null;
  }

  return <>{children}</>;
}
